































































import { Vue, Component, Prop } from "vue-property-decorator";
import {
	db,
	auth,
	busy,
	VIPIp,
	VIPProduction,
	IVIPCertificateProduction,
	VIPCertificate,
	VipIpRequestStatus,
	VIPProductionRest,
} from "@/loader/public";

@Component
export default class ProductionIpRow extends Vue {
	@Prop({ type: Object, required: true })
	public item!: IVIPCertificateProduction;

	@Prop({ type: VIPCertificate, default: null })
	public certificate!: VIPCertificate | null;

	@Prop({ type: Boolean, default: false })
	public canEdit!: boolean;

	public get ip(): VIPIp | null {
		return this.ips.find(ip => ip.code === Number(this.item.ip)) || null;
	}

	public get isBusy(): boolean {
		return busy.status;
	}

	public get ips(): VIPIp[] {
		return this.certificate?.project?.ips.map(pip => pip.ip) || [];
	}
}
